import { toast } from "@/shared/hooks/useToast";
import { api } from "@/shared/libs/axiosClient";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";
import { buildMediaApiVersionRows } from "../libs/mediaApiVersion";
import type { MediaApiVersionsResponse } from "../types/mediaApiVersion";

async function fetchMediaApiVersions(): Promise<MediaApiVersionsResponse> {
    return api.get<MediaApiVersionsResponse>("/versions");
}

export function useMediaApiVersion() {
    const q = useQuery({
        queryKey: ["info", "media-api-version"],
        queryFn: fetchMediaApiVersions,
    });

    const built = useMemo(() => {
        if (!q.data) return null;
        return buildMediaApiVersionRows(q.data);
    }, [q.data]);

    // 렌더 중 중복 toast 방지
    useEffect(() => {
        if (!q.isError) return;
        const msg = q.error instanceof Error ? q.error.message : "서비스가 일시적으로 이용 불가능합니다.";
        toast({ title: "조회 실패", description: msg, variant: "destructive" });
    }, [q.isError, q.error]);

    return {
        ...q,
        rows: built?.rows ?? [],
        summary: built?.summary ?? { itemsLength: 0, channelCount: 0 },
    };
}